import React, { useContext, useEffect, useState } from 'react'
import BidBidderIcon from '../../../../elements/BidBidderIcon/BidBidderIcon'
import BidWhiteCountdown from '@components/BidCountdown/BidWhiteCountdown'
import { ItemCardManger } from '@components/Cards/BidItem'
import BidMsrpButton from 'elements/BidMsrpButton/BidMsrpButton'
import BidIncrementButton from '@components/BidIncrementButton'
import { FaPeopleGroup } from 'react-icons/fa6'
import PickupLocation from '@components/Cards/BidItem/shared/PickupLocation'
import BidCountdown from '@components/BidCountdown/BidCountdown'

const Details = ({ loadingBid, setIncrementModalVisible }: any) => {
  const {
    item: {
      itemClosed = false,
      quantity,
      bidsEnabled = true,
      bidsCount,
      lotCode,
      msrp,
      utcEndDateTime,
      currentBid,
      itemBidIncrementEnabled,
    },
    location,
    itemHandler: { openBidHistory },
    options: { isSimplified },
  } = useContext<any>(ItemCardManger)

  return (
    <>
      {/*<p*/}
      {/*  className="block md:mb-1 "*/}
      {/*  style={quantity > 1 ? { color: 'red', fontWeight: 'bold' } : {}}*/}
      {/*>*/}
      {/*  <span className="font-bold">{itemClosed ? 'SOLD ' : ''}QTY:</span>{' '}*/}
      {/*  {quantity}*/}
      {/*</p>*/}
      <div>
        {bidsEnabled && !isSimplified && (
          <div className="relative">
            <button
              type="button"
              className={`flex items-center transition duration-300 ease-in-out w-max ${
                loadingBid ? ' opacity-25' : 'opacity-100'
              }`}
              onClick={openBidHistory}
            >
              <FaPeopleGroup className={'text-bidfta-blue-light'} />
              <span className="text-bidfta-blue-light font-bold block pl-1">
                {bidsCount} BIDDERS
              </span>
            </button>
          </div>
        )}
        <div
          className={`${
            isSimplified ? '' : 'md:my-1'
          } flex flex-row space-x-1 ${!msrp ? 'invisible' : ''}`}
        >
          <span className="font-bold">MSRP:&nbsp;</span> ${msrp?.toFixed(2)}
          <BidMsrpButton />
          {itemBidIncrementEnabled && (
            <BidIncrementButton setModalVisible={setIncrementModalVisible} />
          )}
        </div>
        {isSimplified ? (
          <PickupLocation
            pickupLocation={location?.nickName}
            isSimplified={isSimplified}
          />
        ) : (
          <></>
        )}
      </div>

      {isSimplified ? (
        <></>
      ) : (
        <p className={`block my-1 ${!lotCode ? 'invisible' : ''}`}>
          <span className="font-bold">{lotCode}</span>
        </p>
      )}
      <Countdown
        itemClosed={itemClosed}
        bidsEnabled={bidsEnabled}
        utcEndDateTime={utcEndDateTime}
        isSimplified={isSimplified}
      />
      {(currentBid === 0 || currentBid) && bidsEnabled ? (
        <span
          className={`block mb-1 md:mb-2.5 text-bidfta-blue-light font-bold transition duration-300 ease-in-out ${
            loadingBid ? ' opacity-25' : 'opacity-100'
          }`}
        >
          CURRENT BID: ${currentBid.toFixed(2)}
        </span>
      ) : null}
    </>
  )
}

const Countdown = ({
  itemClosed,
  bidsEnabled,
  utcEndDateTime,
  isSimplified = false,
}: {
  itemClosed: boolean
  bidsEnabled: boolean
  utcEndDateTime: any
  isSimplified?: boolean
}) => {
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    setIsLoaded(true)
  }, [])

  if (!isLoaded) return <div className={'bg-slate-200 pt-1 md:py-4'} />

  if (itemClosed || !bidsEnabled) return <></>
  return (
    <div className="block md:mb-1">
      {isSimplified ? (
        <BidCountdown date={utcEndDateTime} countdownClass="text-sm" />
      ) : (
        <BidWhiteCountdown
          date={utcEndDateTime}
          textColor="text-blue text-sm"
        />
      )}
    </div>
  )
}

export default Details
